export const ADMIN_API_ENDPOINTS = {
  // Banner Home
  BANNER_HOME: "/admin/v1/banner-home",
  // News
  NEWS: "/admin/v1/news",
  // Offline Tenant Category
  OFFLINE_TENANT_CATEGORY: "/admin/v1/offline-tenant-categories",
  // Sub-category (FnB category) list CRUD
  GOVERN_TENANT_FNB_CATEGORY: "/admin/v1/fnb-categories",
  // F&B Table 
  FNB_TABLE: "/admin/v1/fnb-mall-tables",
  // F&B Product Category (BR005)
  FNB_PRODUCT_CATEGORY: "/admin/v1/fnb-product-categories",
  // F&B Products
  FNB_PRODUCTS: "/admin/v1/fnb-products",
  // Offline Tenants
  OFFLINE_TENANTS: "/admin/v1/offline-tenants",
  /** Gian hàng Online (FK `Tenant`) — dùng cho Milestone ONLINE_SHOPPING. */
  TENANTS: "/admin/v1/tenants",
  /** Event — dùng cho Milestone CHECK_IN_EVENT (FR-03-BR-05). */
  EVENTS: "/admin/v1/events",
  // Floors
  FLOORS: "/admin/v1/floors",
  // Customer Review
  CUSTOMER_REVIEW: "/admin/v1/tenant-reviews",
  // Tenant Voucher
  TENANT_VOUCHER: "/admin/v1/tenant-vouchers",
  // Offline Tenant Voucher
  OFFLINE_TENANT_VOUCHER: "/admin/v1/offline-vouchers",
  // Offline Tenant Voucher Stats
  OFFLINE_TENANT_VOUCHER_STATS: "/admin/v1/offline-vouchers/stats",
  // Offline Tenant Voucher List of Codes
  OFFLINE_TENANT_VOUCHER_LIST_OF_CODES: "/admin/v1/offline-vouchers/:id/codes",
  OFFLINE_TENANT_VOUCHER_LIST_OF_CODES_EXPORT:
    "/admin/v1/offline-vouchers/:id/codes/export",
  // Notification Templates
  NOTIFICATION_TEMPLATES: "/admin/v1/notifications/templates",
  // Tenant Booking bundles
  TENANT_BOOKING: "/admin/v1/offline-tenant-booking",
  // Mall Facilities
  MALL_FACILITIES: "/admin/v1/mall-facilities",
  // Mall Facilities booking history
  MALL_FACILITY_BOOKING_HISTORY:
    "/admin/v1/mall-facilities/:id/booking-history",
  // Mall Facility Bookings
  MALL_FACILITY_BOOKINGS: "/admin/v1/mall-facility-bookings",
  // Customer Feedback
  CUSTOMER_FEEDBACK: "/admin/v1/customer-feedback",
  // Chatbot
  CHATBOT: "/admin/v1/chatbot",
  // Payment methods (F&B)
  PAYMENT_METHODS: "/admin/v1/payment-methods",
  // Offline tenant ordering (F&B Tenant Food Ordering)
  OFFLINE_TENANT_ORDERING: "/admin/v1/offline-tenant-ordering",
  // F&B Orders (governance)
  FNB_ORDERS: "/admin/v1/fnb-orders",
  // Floor Map Interactive (F-BR002/F-BR003/F-BR006/F-BR007)
  FLOOR_MAP_INTERACTIVE: "/admin/v1/floors-map-interactive",

  // ---------------------------------------------------------------------------
  // Stamp Collection (FR-01 → FR-09)
  // Path thật do BE cung cấp 2026-08-14 (API Design.md sheet List, API #1-23).
  // Đối chiếu field-level: docs/stamp-collection/API-MAPPING.md
  // ---------------------------------------------------------------------------
  /** API #9-16 — Challenge CRUD + Milestone QR. */
  CHALLENGE: "/admin/v1/stamp-collection/challenges",
  /** API #1-2 — cấu hình dùng chung (FR-08). */
  CHALLENGE_CONFIGURATION: "/admin/v1/stamp-collection/challenge-configuration",
  /** API #4-7 — Reward history / summary / export (FR-07). Không còn nested dưới challenge. */
  CHALLENGE_REWARD: "/admin/v1/stamp-collection/challenge-rewards",
  /** API #8 — danh sách Reward Code của 1 Reward Option (không cần challengeId). */
  CHALLENGE_REWARD_OPTION: "/admin/v1/stamp-collection/challenge-reward-options",
  /** API #17-20 — Stamp Request (FR-05). */
  CHALLENGE_STAMP_REQUEST: "/admin/v1/stamp-collection/challenge-stamp-requests",
  /** API #21-23 — Stamp history / summary / export (FR-06). */
  CHALLENGE_STAMP: "/admin/v1/stamp-collection/challenge-stamps",
} as const;
